import ActionType from '../../actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Tasks.LIST_TYPES_SUCCESS:
      return (
        (Array.isArray(action.payload) &&
          action.payload.reduce(
            (newTypesByID, taskType) => {
              newTypesByID[taskType.id] = taskType
              return newTypesByID
            },
            { ...state },
          )) ||
        state
      )
    default:
      return state
  }
}
